import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  FrenchiseUser: [],
  Online: [],
  COD: [],

};
//internally using immer lib (can create mutable state)
export const frenchiseUserSlice = createSlice({
  name: "frenchiseUserData",
  initialState,
  reducers: {
    updateAllFrenchiseUser: (state, action) => {
      state.FrenchiseUser = action.payload;
    },
    updateUserOnline: (state, action) => {
      state.Online = action.payload;
    },
    updateUserCOD: (state, action) => {
      state.COD = action.payload;
    },
  },
});
// this is for dispatch
export const { updateAllFrenchiseUser,updateUserCOD, updateUserOnline} = frenchiseUserSlice.actions;
// this is for configureStore
export default frenchiseUserSlice.reducer;
